import { supabase } from '../supabase';

/** Team Testing Leaderboards — SESSION + SEASON (first leaderboard
 * phase, 054). Both are Team-staff/management-authorized, read-only
 * views derived entirely from the existing canonical test_attempts/
 * testing_sessions rows — no new table, nothing stored or cached here.
 *
 * Eligibility (enforced server-side, 054): testing_sessions.team_id =
 * this exact team — Personal Testing (team_id null) and any other
 * Team's results are excluded by construction, regardless of
 * capture_method or verification_status.
 *
 * testDate is OPTIONAL and must be OMITTED (never passed as null) to
 * let the RPC's own `default current_date` apply — record_team_test_
 * attempt()'s p_capture_method-style "pass null explicitly" convention
 * does NOT apply here, because get_team_session_leaderboard's own
 * p_test_date validation (`if p_test_date is null then raise
 * exception`) would reject an explicit null rather than defaulting it —
 * PostgreSQL only substitutes a parameter's DEFAULT when the argument is
 * OMITTED from the call, never when NULL is explicitly supplied. */
export async function getTeamSessionLeaderboard({ teamId, testType, testDate }) {
  const params = { p_team_id: teamId, p_test_type: testType };
  if (testDate) params.p_test_date = testDate; // omitted entirely -> RPC's own current_date default
  const { data, error } = await supabase.rpc('get_team_session_leaderboard', params);
  if (error) throw error;
  return data || [];
}

/** SEASON — Team + test_type, every eligible date for this team_id.
 * team_id alone already implies the Season (a teams row is inherently
 * one-season-scoped, 054's own header) — no season/date parameter
 * exists to pass. */
export async function getTeamSeasonLeaderboard({ teamId, testType }) {
  const { data, error } = await supabase.rpc('get_team_season_leaderboard', {
    p_team_id: teamId,
    p_test_type: testType,
  });
  if (error) throw error;
  return data || [];
}
